<template>
  <div class="c-app-side-panel fs">
    <div class="placehodler flex-main">&nbsp;</div>
    <div class="actions__wrapper">
      <ul class="actions">
        <li v-for="(it, index) in innerActions" class="action-item" :key="`ai_${index}`">
          <CAppSideAction v-bind="it" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { _, computed, onMounted, reactive, ref, watch, useHostAppInstance } from '@zto/zpage'
import { GLOBAL_EVENTS } from '@zto/tuxi-operate-web-base'

const app = useHostAppInstance()

const innerActions = computed(() => {
  return [
    {
      icon: 'https://fscdn.zto.com/GetPublicFile/clouddrive/s3:cloudm:clouddrive:f714540e5db4480f8242b405ce405d5e.png',
      label: '兔喜客服',
      event: GLOBAL_EVENTS.OPEN_CUSTOM_SERVICE,
      plugin: 'CAppSideCustomerService'
    },
    {
      icon: 'https://fscdn.zto.com/GetPublicFile/clouddrive/s3:cloudm:clouddrive:14d0ddb4bd9c4fba88b891cecbf75fb7.png',
      label: '帮助中心',
      event: GLOBAL_EVENTS.OPEN_HELPER,
      plugin: 'CAppSideHelper'
    }
  ]
})
</script>

<style lang="scss" scoped>
.c-app-side-panel {
  background: hsla(0, 0%, 100%, 0.51);
  display: flex;
  flex-direction: column;
}

.actions {
  width: 100%;
  padding: 0px;
  &__wrapper {
    padding-bottom: 150px;
  }

  .action-item {
    padding-top: 16px;
  }
}
</style>
